var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E22022"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddi_2017_907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5398 16.8528C25.4742 16.8528 25.4185 16.8397 25.3725 16.8135C25.3266 16.7873 25.2905 16.7414 25.2643 16.6759L24.6936 15.339L23.2569 14.7099C23.1913 14.6837 23.1454 14.6477 23.1192 14.6018C23.0929 14.5559 23.0798 14.5002 23.0798 14.4347C23.0798 14.3692 23.0929 14.3135 23.1192 14.2676C23.1454 14.2217 23.1913 14.1857 23.2569 14.1595L24.6936 13.55L25.2643 12.2722C25.2905 12.2066 25.3266 12.1607 25.3725 12.1345C25.4185 12.1083 25.4742 12.0952 25.5398 12.0952C25.6054 12.0952 25.6612 12.1083 25.7071 12.1345C25.753 12.1607 25.7891 12.2066 25.8153 12.2722L26.386 13.55L27.8227 14.1595C27.8883 14.1857 27.9342 14.2217 27.9604 14.2676C27.9867 14.3135 27.9998 14.3692 27.9998 14.4347C27.9998 14.5002 27.9867 14.5559 27.9604 14.6018C27.9342 14.6477 27.8883 14.6837 27.8227 14.7099L26.386 15.339L25.8153 16.6759C25.7891 16.7414 25.753 16.7873 25.7071 16.8135C25.6612 16.8397 25.6054 16.8528 25.5398 16.8528ZM25.5398 28.5699C25.4873 28.5699 25.4349 28.5568 25.3824 28.5306C25.3299 28.5044 25.2905 28.4585 25.2643 28.393L24.6936 27.1151L23.2766 26.5056C23.211 26.4794 23.1651 26.4434 23.1389 26.3975C23.1126 26.3516 23.0995 26.2959 23.0995 26.2304C23.0995 26.1649 23.1126 26.1092 23.1389 26.0633C23.1651 26.0174 23.211 25.9814 23.2766 25.9552L24.6936 25.3457L25.2643 23.9892C25.2905 23.9237 25.3266 23.8778 25.3725 23.8516C25.4185 23.8254 25.4742 23.8123 25.5398 23.8123C25.6054 23.8123 25.6612 23.8254 25.7071 23.8516C25.753 23.8778 25.7891 23.9237 25.8153 23.9892L26.386 25.3457L27.803 25.9552C27.8686 25.9814 27.9145 26.0174 27.9408 26.0633C27.967 26.1092 27.9801 26.1649 27.9801 26.2304C27.9801 26.2959 27.967 26.3516 27.9408 26.3975C27.9145 26.4434 27.8686 26.4794 27.803 26.5056L26.386 27.1151L25.8153 28.393C25.7891 28.4585 25.7497 28.5044 25.6973 28.5306C25.6448 28.5568 25.5923 28.5699 25.5398 28.5699ZM16.9003 25.1688C16.7953 25.1688 16.6937 25.1393 16.5953 25.0803C16.4969 25.0214 16.4214 24.9394 16.369 24.8346L15.0898 22.1019L12.3346 20.8634C12.2296 20.8109 12.1476 20.7356 12.0886 20.6373C12.0295 20.539 12 20.4374 12 20.3326C12 20.2277 12.0295 20.1261 12.0886 20.0278C12.1476 19.9295 12.2296 19.8542 12.3346 19.8018L15.0898 18.5632L16.369 15.8502C16.4214 15.7322 16.4969 15.6438 16.5953 15.5848C16.6937 15.5258 16.7953 15.4963 16.9003 15.4963C17.0053 15.4963 17.1069 15.5258 17.2053 15.5848C17.3037 15.6438 17.3792 15.7257 17.4317 15.8305L18.7305 18.5632L21.4661 19.8018C21.5841 19.8542 21.6727 19.9295 21.7317 20.0278C21.7908 20.1261 21.8203 20.2277 21.8203 20.3326C21.8203 20.4374 21.7908 20.539 21.7317 20.6373C21.6727 20.7356 21.5841 20.8109 21.4661 20.8634L18.7305 22.1019L17.4317 24.8346C17.3792 24.9525 17.3037 25.0377 17.2053 25.0902C17.1069 25.1426 17.0053 25.1688 16.9003 25.1688Z",
    fill: "url(#paint0_linear_2017_907)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddi_2017_907",
    x: 5.63323,
    y: 6.53344,
    width: 28.0017,
    height: 29.5741,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.31726,
    dy: 2.48816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.52475
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0506089 0 0 0 0 0.0159861 0 0 0 0 0.191833 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2017_907"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.24408,
    dy: -1.1709
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.19544
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2017_907",
    result: "effect2_dropShadow_2017_907"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2017_907",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.07361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9393
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_2017_907"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2017_907",
    x1: 22.7967,
    y1: 19.8499,
    x2: 20.3181,
    y2: 31.3725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.23
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAvatar);
export default __webpack_public_path__ + "static/media/AI Avatar.d0d35e156de00ba496647fad4066c5fc.svg";
export { ForwardRef as ReactComponent };